import { displayMessage } from './utility/message';
import { MessageType } from './utility/messageTypes';
import { apiRequest } from './utility/apiRequest'; // Assuming you have an apiRequest utility

// Main functionality for adding products to the cart
document.addEventListener('DOMContentLoaded', () => {
    const addToCartForms = document.querySelectorAll('.ambikly-add-to-cart');
    const productSection = document.querySelector('.ambikly-product-section') as HTMLElement | null;

    if (!productSection) return; // Exit early if the product section is not found

    addToCartForms.forEach(form => {
        form.addEventListener('submit', async (e: Event) => {
            e.preventDefault();

            const formData = new FormData(form as HTMLFormElement);

            try {
                const response = await apiRequest((window as any).ambikly.ajax_url, {
                    method: 'POST',
                    body: formData,
                });

                const jsonResponse: { success: boolean; data: { message: string } } = JSON.parse(response);

                if (jsonResponse.success) {
                    displayMessage(productSection as HTMLElement, jsonResponse.data.message, MessageType.SUCCESS, true);
                } else {
                    displayMessage(productSection as HTMLElement, jsonResponse.data.message || 'Failed to add product to cart.', MessageType.ERROR, true);
                }
            } catch (error) {
                console.error('Error during form submission:', error);
                displayMessage(productSection as HTMLElement, 'An error occurred while processing your request.', MessageType.ERROR, true);
            }
        });
    });
});

